import React from "react";
import { PageDownload } from "@aspen/pages";

const Download: React.FC = () => {
  return <PageDownload />;
};

export default Download;
